import Vue from "vue";

// PLUGIN
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import "./plugins/notification";
import "./plugins/components";

// LOADER
import "./loaders";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "normalize.css";
import "./styles/fonts.css";
import "./styles/index.css";

import "./filters";
import "./components/auto-register";
import "./components-model/auto-register";
import "./components-broadcast/auto-register";

Vue.config.productionTip = false;

// utils — null/undefined도 "비어있음"으로 처리(Object.keys(undefined) 크래시 방지)
Object.isEmpty = (obj) => !obj || Object.keys(obj).length === 0;

// 이걸하면 template reload를 못하네
// if (module.hot) {
//   module.hot.accept(); // already had this init code

//   module.hot.addStatusHandler((status) => {
//     if (status === "prepare") console.clear();
//   });
// }

const vue = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
